import React from "react";
import football from "../../assets/images/sports/football.jpg";

function HeroHomeOne({ className }) {
  return (
    <>
      <section className={`appie-hero-area ${className || ""}`}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="appie-hero-content">
                {/* <span>JITO Ball-A-Thon</span> */}
                <h1 className="appie-title">Football Ground 1</h1>
                {/* <ul>
                  <li>
                    <a href="https://www.youtube.com/live/VbYh85pE6yU">
                      <i className="fab fa-youtube" /> YouTube Live
                    </a>
                  </li>
                </ul> */}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="appie-hero-thumb">
                <div
                  className="thumb wow animated fadeInUp"
                  data-wow-duration="2000ms"
                  data-wow-delay="200ms"
                >
                  <img src={football} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default HeroHomeOne;
